<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-alert v-if="callbackError" type="error" prominent text>
        {{ callbackError }}
        <template v-slot:append>
          <v-btn outlined color="error" @click="$router.replace({ name: 'login' })">
            {{ $t("login") }}
          </v-btn>
        </template>
      </v-alert>
      <v-progress-linear v-else indeterminate />
    </v-col>
  </v-row>
</template>

<script>
import checkPermissions from "@/router/permissions";
import { consumeNext } from "@/auth/keycloak";

export default {
  name: "SsoCallback",
  data: () => ({
    callbackError: null,
  }),
  mounted() {
    if (!this.$store.getters.isReady) {
      this.callbackError = this.$store.state.systemError
        ? this.$store.state.systemError.msg
        : this.$t("ssoLoginFailed");
      this.$store.commit("setSystemError");
      return;
    }

    const nextPath = consumeNext();
    const next = nextPath ? this.$router.resolve(nextPath) : null;

    if (
      next != null &&
      next.route.matched.length > 0 &&
      next.route.name !== "sso-callback" &&
      checkPermissions(next.route)
    ) {
      this.$router.replace(next.route.fullPath);
    } else {
      this.$router.replace({ name: "home" });
    }
  },
};
</script>

<i18n>
{
  "en": {
    "login": "Login",
    "ssoLoginFailed": "SSO login failed"
  },
  "de": {
    "login": "Anmelden",
    "ssoLoginFailed": "SSO-Anmeldung fehlgeschlagen"
  }
}
</i18n>
